/**
 * Local storage wrapper
 */

import * as Window from "../Utils/Window";

/**
 * Code to detect localStorage presence.
 * Copied from MDN: https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
 */
export function isStorageAvailable(): boolean {
	try {
		const x = "__storage_test__";
		Window.getGlobal().localStorage.setItem(x, x);
		Window.getGlobal().localStorage.removeItem(x);
		return true;
	} catch (e) {
		return e instanceof DOMException && (
			// everything except Firefox
			e.code === 22 ||
			// Firefox
			e.code === 1014 ||
			// test name field too, because code might not be present
			// everything except Firefox
			e.name === "QuotaExceededError" ||
			// Firefox
			e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
			// acknowledge QuotaExceededError only if there's something already stored
			Window.getGlobal().localStorage.length !== 0;
	}
}

/**
 * Safely read an object
 */
export function readObjectFromStorage<T>(storageKey: string, defaultValue?: T): T {
	if (!storageKey) {
		return defaultValue;
	}

	try {
		const result = Window.getGlobal().localStorage.getItem(storageKey);
		const parsedObject = result && (result[0] === "{" || result[0] === "[") ? JSON.parse(result) : result;
		return parsedObject ?? defaultValue;
	} catch (e) {
		// ignore
	}

	return defaultValue;
}

/**
 * Write to the localStorage
 */
export function writeToStorage<T>(storageKey: string, content: T): void {
	if (!storageKey || !content) {
		return;
	}

	try {
		const contentString = typeof content === "string" ? content : JSON.stringify(content);
		Window.getGlobal().localStorage.setItem(storageKey, contentString);
	} catch (e) {
		// ignore
	}
}
